module.exports = __webpack_public_path__ + "7352285a907ddf4fef7b50f22c628054.svg";